import { injectable } from 'inversify';
import { 
  IMercadoPagoRepository, 
  CreateMpPreferenceRequest, 
  CreateMpPreferenceResponse 
} from '@/domain/repositories/IMercadoPagoRepository';
import { httpClient } from '@/infrastructure/http/client/httpClient';

/**
 * Implementación del repositorio de Mercado Pago (Adapter)
 */
@injectable()
export class MercadoPagoRepository implements IMercadoPagoRepository {
  
  async createPreference(request: CreateMpPreferenceRequest): Promise<CreateMpPreferenceResponse> {
    try {
      const response = await httpClient.post('/mercadopago/preference', request);
      return response.data;
    } catch (error: any) {
      console.error('Error creating Mercado Pago preference:', error);
      throw new Error(
        error.response?.data?.message || 
        'Error al crear preferencia de pago en Mercado Pago'
      );
    }
  }
}
